<template>
    <div class="row tableRow align-items-center">
        <div class="col-12 col-sm-5 col-lg-6">
            <div class="row">
                <div class="col-4 margin-nagative-15-left">
                  <a :href="item.detail" :title="item.name">
                    <img :src="item.thumb"/>
                  </a>
                </div>
                <div class="col-8">
                    <a :href="item.detail" :title="item.name">
                        {{ item.name }}
                    </a>
                    <div class="price">{{ item.brutto_price | money }}/{{ item.unit }}</div>
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-3 col-lg-2 text-center">

            <spinner
                v-model="qty"
                :value="qty"
                :step="item.step"
                :min="item.min_order"
                :max="item.max_order"
                :precision="item.precision"
                :unit="item.unit"
                @input="update">
            </spinner>

            <div v-if="false" class="input-group spinner">
                <div class="input-group-prepend">
                    <button class="btn btn-outline-medium-gray btn-outline-light" type="button"><div class="icon icon-minus"></div></button>
                </div>
                <input type="text" class="form-control" :value="formatQuantity(item) + ` x  ${item.unit}`" aria-label="" aria-describedby="basic-addon1">
                <div class="input-group-append">
                    <button class="btn btn-outline-medium-gray btn-outline-light" type="button"><div class="icon icon-plus"></div></button>
                </div>
            </div>

        </div>
        <div class="col-2 col-sm-2 text-center">
            {{ item.discount }} %
        </div>
        <div class="col-2 col-sm-1 text-right">
            <template v-if="item.is_discounted">
              <span class="text-line-through">{{ item.brutto_price * item.qty | money }}/{{ item.unit }}</span>
              <br>
            </template>
            {{ item.price * item.qty | money }}
        </div>
        <div class="col-2 col-sm-1 text-right align-center">
            <a href="#" @click.prevent="removeItem({id: item.id, row: item.rowId})">
                <div class="icon icon-close"></div>
            </a>
        </div>
    </div>
</template>

<script>
import Spinner from '@Components/common/Spinner'
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('cart')

export default {

    components: {
        Spinner
    },

    props: {
        item: {
            default: null,
            required: true,
            type: Object
        }
    },

    data() {
        return {
            qty: this.item.qty
        }
    },

    methods: {

        ...mapActions(['removeItem', 'updateQty']),

        async update() {
            await this.updateQty({
                id: this.item.id,
                row: this.item.rowId,
                qty: this.qty
            })
        },

        formatQuantity(item) {
            return item.unit == 'm' ? parseFloat(item.qty).toFixed(1).replace('.', ',') : parseInt(item.qty)
        },
    },

    filters: {

        money(value) {
            return parseFloat(value).toLocaleString('sl-SI', {style: 'currency', currency: 'EUR'});
        }
    },

    watch: {

        item: {
            deep: true,
            handler: function() {
                this.qty = this.item.qty
            }
        }
    }

}
</script>
